﻿<template>
    <div class="td">
        <tour_heading :product=product></tour_heading>

        <button type="button" class="td-jump" @click="goTo('calendar_div')">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12l7 7 7-7" /></svg>
            Jump to dates
        </button>

        <div class="td-grid">
            <section class="td-card" aria-labelledby="td-dates-title">
                <div class="td-card-head">
                    <h4 id="td-dates-title" class="td-card-title">Choose your departure date</h4>
                    <span v-if="isCalendarAddonTour()" class="td-addon-note">
                        <span aria-hidden="true">*</span> {{add_on_name}} add-on available
                    </span>
                </div>

                <div class="td-selected" :class="{ 'is-empty': !get_Selected_Date() }" aria-live="polite">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                    <span v-if="get_Selected_Date()">Selected date: <strong>{{ get_Selected_Date() }}</strong></span>
                    <span v-else>No date selected yet. Pick a highlighted day below.</span>
                </div>

                <calendar class="tour-calendar" id="calendar_div" :trip_index="trip_index" :product="product" :tour_ids="tour_ids" :selected_tour_id="get_Calendar_Tour_Id()" @monthChange="onMonthChange" @dateChange="onDateChange" ref="calendar"></calendar>

                <div v-if="!isAgent_Login() && tempBookingNotes(product?.tour_id)" class="td-contact">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
                    <span v-html="getTempBookingNotes()"></span>
                </div>
            </section>

            <aside class="td-card td-panel" aria-labelledby="td-trip-title">
                <h4 id="td-trip-title" class="td-card-title">Your trip</h4>
                <passenger_details :hidden_initially=false @calendar_update="onCalendarUpdate" ref="passenger_details" :tour_id=tour_id></passenger_details>
                <pickup_point :trip_index=trip_index ref="pickup_points"></pickup_point>
                <sales_group :trip_index=trip_index :tour_id=tour_id  :year="year" :month="month" @selectedTour="onSelectedTour" ref="sales_group"></sales_group>
                <basket :trip_index=trip_index :tour_id="tour_id" @Add_To_Cart="Add_To_Cart"></basket>
            </aside>
        </div>
    </div>
</template>

<script lang="ts" src="./tour_details.ts"></script>